import { SIcon } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';
import { LightGreyRoundedBox } from '../styled';

const EmptyCartContainer = styled(LightGreyRoundedBox)`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(196,196,196);
`;

const EmptyCartPanel = () => (
  <EmptyCartContainer className='pad-all-sm' data-ref='empty-cart-panel'>
    <SIcon name='shopping-cart' className='text-xxl' />
  </EmptyCartContainer>
);
export default EmptyCartPanel;
